import { useCallback, useMemo } from 'react';
import {
  useRouteMatch,
  useHistory,
  useLocation,
  matchPath,
} from 'react-router';

/**
 *
 * @param defaultTab
 * @param customTransitions - если нужно модифицировать часть переходов, например, чтобы editData вел на editData/default
 * @returns [tab, onTabChange]
 */
export function useRoutedTabs<T extends string>(
  defaultTab: T,
  customTransitions?: Record<T, string>
) {
  const { url } = useRouteMatch();
  const history = useHistory();
  const location = useLocation();

  const onTabChange = useCallback(
    (key: T) => {
      let endpoint: string = key;
      if (customTransitions && customTransitions[key]) {
        endpoint = customTransitions[key];
      }
      history.push(`${url}/${endpoint}`.replace('//', '/'));
    },
    [url, history, customTransitions]
  );

  const tab = useMemo(() => {
    const match = matchPath<{ tab: string }>(location.pathname, {
      path: `${url}/:tab`,
    });
    return match ? match.params.tab : defaultTab;
  }, [url, location, defaultTab]);

  return [tab, onTabChange] as const;
}
